import { render, staticRenderFns } from "./Gav.vue?vue&type=template&id=92dd1a98&scoped=true&class=GlobalAddressValidation&"
import script from "./Gav.vue?vue&type=script&lang=js&"
export * from "./Gav.vue?vue&type=script&lang=js&"
import style0 from "./Gav.vue?vue&type=style&index=0&id=92dd1a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dd1a98",
  null
  
)

export default component.exports